<template>
	<article :class="['capsule-article', `capsule-article--${propId}`,isInViewport && !getRouteLeave ? 'capsule-article--appear' : '', choiced ? 'capsule-article--choiced' : '']" v-bind:style="{ transitionDuration: `${transitionDuration}s`, transitionDelay: `${transitionDelay}s` }">
		<router-link :to="`/${contentData.slug}`" @click.native="isChoiced">
			<div class="capsule-article__img-container">
				<div class="capsule-article__scene" ref="scene">
					<!-- <img data-depth=".2" :src="contentData.acf.main_picture_project.sizes.medium" :alt="contentData.title.rendered"> -->
					<vue-img-loader data-depth=".2" :preview="contentData.acf.main_picture_project.sizes.medium" :src="contentData.acf.main_picture_project.url" transition="fadeIn" :blur-preview="false">
					  <div data-depth="0" class="capsule-article__spinner-container">
							<div class="capsule-article__spinner" ></div>
						</div>
					</vue-img-loader>
				</div>
			</div>

			<p class="capsule-article__title-container" v-bind:style="{ transitionDuration: `${transitionDuration}s`, transitionDelay: `${transitionDelay}s` }">
				<!-- <i class="icon-right-arrow"></i> -->
				<span>{{ contentData.title.rendered }}</span>
				<span v-if="contentData.acf.customer_project" class="capsule-article__customer">{{ contentData.acf.customer_project }}</span>
			</p>
		</router-link>
	</article>
</template>

<script>
	import Parallax from 'parallax-js'
	import scrollMonitor from 'scrollmonitor'
	import VueImgLoader from 'vue-img-loader'

	export default {
		name: 'capsule-article',
		components: {
			VueImgLoader
		},
		props: [
			'contentData',
			'propId'
		],
		data () {
			return {
				isInViewport: false,
				transitionDuration: (Math.random() * (20 - 15) + 15) / 10,
				transitionDelay: (Math.random() * 5) / 10,
				sceneId: `capsuleArticle-${this.propId}`,
				choiced: false
			}
		},
		mounted () {
			/*
			* Init parallax
			*/
			if (!this.getMobile) {
				this.initParallax()
			}

			/*
			* Check if in viewport
			*/
			const self = this

			setTimeout(() => {
				const elementWatcher = scrollMonitor.create(self.$el)

				elementWatcher.enterViewport(() => {
					self.isInViewport = true

					if (this.parallax) {
						self.parallax.enable()
					}
				})

				elementWatcher.exitViewport(() => {
					self.isInViewport = false

					if (this.parallax) {
						self.parallax.disable()
					}
				})
			}, 0)
		},
		methods: {
			initParallax () {
				const scene = this.$refs.scene
				this.parallax = new Parallax(scene, {
					hoverOnly: true,
					relativeInput: true,
					invertX: false,
					invertY: false
				})
			},
			isChoiced () {
				this.choiced = true
			}
		},
		watch: {
			getRouteLeave (val) {
				if (val) {
					this.transitionDuration = this.transitionDuration / 2
					this.transitionDelay = this.transitionDelay / 2
				}
			},
			getViewport () {
				if (this.parallax && !this.getMobile) {
					this.parallax.destroy()

					this.initParallax()
				}
			}
		},
		computed: {
			getRouteLeave () {
				return this.$store.getters.getRouteLeave
			},
			getViewport () {
				return this.$store.getters.getViewport
			},
			getMobile () {
				return this.$store.getters.getMobile
			}
		}
	}
</script>

<style lang="scss">
	.capsule-article {
		width: 200px;
		height: 340px;
		max-width: 70%;
		opacity: 0;
		transform: translateY(50px);
		transition: all .4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

		@include custom-break-min(1450px) {
			width: 277px;
			height: 390px;
		}

		@include tablet-to-mobile {
			width: calc(85% / 3);
		}

		@include mobile {
			width: 100%;
			height: auto;
			max-width: 100%;
			margin-bottom: 30px;
		}

		&.capsule-article--appear,
		&.capsule-article--choiced {
			opacity: 1;
			transform: translateY(0);

			p {
				opacity: 1;
				transform: translateY(0);
			}
		}

		&.capsule-article--choiced {
			.capsule-article__img-container::before {
				width: 100%;
			}

			p span {
				opacity: 0;
				transform: translateY(0) translateX(30px);
			}
		}

		.capsule-article__img-container {
			position: relative;

			&::before {
				position: absolute;
				z-index: 9;
				top: 0;
				bottom: 0;
				left: 0;
				width: 0;
				background: $basic_white;
				content: '';
				transition: all .6s cubic-bezier(0.215, 0.61, 0.355, 1);
			}
		}

		a,
		.capsule-article__img-container {
			height: 100%;
		}

		.capsule-article__img-container {
			overflow: hidden;

			> div {
				position: relative;
				width: 100%;
				height: 100%;
			}

			img {
				width: 100%;

				@include custom-break-min($mobile) {
					top: 0 !important;
					left: 0 !important;
					width: 100% !important;
					height: auto !important;
				}
			}
		}

		p {
			position: relative;
			overflow: hidden;
			opacity: 0;
			margin-top: 5px;
			transform: translateY(30px);
			text-align: right;
			@include fontSize(14);
			transition: all .4s cubic-bezier(0.175, 0.885, 0.32, 1.275);

			@include mobile {
				text-align: center;
				@include fontSize(22);
			}

			span {
				display: block;
				@include transition(all .4s);
			}
		}

		&:hover p {
			opacity: 0.5;
			transform: translateX(-10px);
		}
	}

	.capsule-article__customer {
		margin-top: 5px;
		font-style: italic;
	}

	.capsule-article__spinner-container {
		position: absolute !important;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
	}

	.capsule-article__spinner {
		position: absolute;
		top: 50%;
		left: 50%;
	  width: 40px;
	  height: 40px;
	  margin: 0 auto;
	  background-color: $basic_black;
	  border-radius: 100%;
	  animation: sk-scaleout 1s infinite ease-in-out;
	}

	@keyframes sk-scaleout {
	  0% {
	    transform: translate(-50%, -50%) scale(0);
	  }

	  100% {
	    transform: translate(-50%, -50%) scale(1);
	    opacity: 0;
	  }
	}

	.capsule-article__scene {
		@include mobile {
			> div {
				height: auto !important;
				margin: auto;
			}

			img {
				position: relative !important;
				top: 0 !important;
				left: 0 !important;
				width: 100% !important;
				height: auto !important;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/common/article/Capsule.vue?5a389cb7